define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function init($progress) {
    }
    exports.init = init;
    function setState(state) {
        $('.progress-mask').attr('class', "progress-mask " + state.className);
        $('.progress-mask').toggleClass('hidden', state.visibility === 'hidden');
        $('.progress-mask label').text(state.label);
        $('.progress-mask input').val(state.input);
    }
    exports.setState = setState;
    function copyLink(e) {
        e.preventDefault();
        e.stopPropagation();
        var $val = $(e.currentTarget).prev('a');
        var input = $val[0];
        input.select();
        input.setSelectionRange(0, 1000);
        document.execCommand('copy');
        setState({
            visibility: "hidden",
            className: '',
            label: ''
        });
    }
    exports.copyLink = copyLink;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/progress.js
// module id = 37
// module chunks = 0